import Arrow from "../../../../shared/Icons/Arrow";
import Delete from '../../../../shared/Icons/Delete'
import TextField from '../../../../shared/TextField/TextField'
import AsyncButton from '../../../../shared/Loading/AsyncButton';

const FaqItem = (props) => {
  const isOpen = props.openId === props.index;

  return (
    <div className={`border border-gray-300 border-b-0 last:border-b ${props.isEditor || !isOpen ? 'bg-gray-100' : 'bg-white'}`}>
      <div className="flex items-center justify-between gap-3 px-3 py-3 sm:px-4">
        <div className="flex items-start gap-3 flex-1">
          <span className="text-sm font-semibold text-gray-800">{props.index}. </span>
          <TextField
            isEditor={props.isEditor}
            id={props.item.Id}
            field="Question"
            value={props.item.Question}
            setData={props.setQuestions}
            className={'font-semibold text-gray-800'}
          />
        </div>
        {props.isEditor &&
          <AsyncButton light
            onClick={() => props.deleteQuestion(props.item.Id)}
            className="p-1 text-red-500 hover:bg-red-50 rounded transition"
          >
            <Delete />
          </AsyncButton>
        }
        <button
          type="button"
          onClick={() => props.setOpenId(isOpen ? null : props.index)}
          className="shrink-0 p-1 hover:bg-gray-100 rounded transition"
        >
          <Arrow turn={isOpen ? 'up' : 'down'} />
        </button>
      </div>
      {isOpen && (
        <div className="bg-white px-3 py-4 text-sm leading-6 text-gray-600 sm:px-4">
          <TextField
            isEditor={props.isEditor}
            id={props.item.Id}
            field="Answer"
            value={props.item.Answer}
            setData={props.setQuestions}
          />
        </div>
      )}
    </div>
  );
};

export default FaqItem;
